<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/pwN7kQ/tc-custom/9781911420163.jpg?1726519075364" alt="This image is the cover for the book Apocalypse Fire, An Ava Curzon Thriller"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Apocalypse Fire, An Ava Curzon Thriller
      </h1>
      <p class="bookDescription body article font2">
        <p>  </p><p><b>An archaeologist and ex-spy goes toe to toe with a Russian cult for the fate of the world in this international adventure thriller.</b></p><p> When the Turin Shroud is stolen in a violent assault, archaeologist and former spy Ava Curzon is plunged into a desperate struggle against the leader of an apocalyptic Russian cult. Recruited by the UK’s clandestine MI13 intelligence agency—and aided by the Vatican’s security division and her former colleague Ferguson—Ava is sucked into a world of dark extremism and Biblical secrets. </p><p> As the chase catapults her around Europe, she must unravel the mysteries of an ancient icon belonging to the shadowy Order of Malta. With time running out, and cataclysmic war in the Middle East the price of failure, the world stands on the brink . . . </p><p><b>Perfect for readers of Dan Brown and Scott Mariani</b></p><p><b>Praise for <i>The Apocalypse Fire</i></b></p><p><b><i> </i>“Imagine the best of James Bond and the Da Vinci Code rolled into one, and that is what you get with this book.” —<i>Soldier Magazine</i></b></p><p><b>“Keeps the tension ratcheted up . . . Selwood breathes life into the conspiracy thriller by knowing his history and deploying it well.” —<i>The Catholic Herald</i> </b></p><b>“The fast pace of the story continues throughout . . . Selwood is one to watch.” —<i>Quench Magazine</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dominic Selwood
      </h2>
      
      <p class="authorDescription body article"><P>Dominic Selwood is a fan of everything historical, the quirkier the better. He writes on history for the UK’s Daily Telegraph, and contributes to a range of other newspapers and magazines. He appears regularly on television and radio. He is the author of <I>Knights of the Cloister</I> on the Knights Templar, and also writes ghost stories. He has a doctorate from the University of Oxford, and degrees from the Sorbonne, London, Poitiers, and Wales. He has taught and lectured in the UK and Europe on warfare, religion, the crusades, Templars, heresy, law, and all the fun stuff. He is an elected Fellow of the Royal Historical Society, and lives in London with his wife and their two children.</P><P>www.dominicselwood.com</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1158aa5b